<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <div v-else>
        <b-row class="mb-15">
            <custom-multiselect v-model="daxTtIdSelected"
                                :options="options"
                                placeholder="Выберите DAX TtId"
                                :internal-search="false"
                                @search-change="changeDAXTtId"
                                @select="getForDaxTtId" />
        </b-row>

        <b-row class="m-0">
            <b-col v-if="loadTma.Loading" class="container-tab-spinner">
                <spinner />
            </b-col>
            <b-col v-else class="p-0" md="6" lg="4" sm="12">
                <b-list-group>
                    <b-list-group-item  
                                    v-for="(item, index) in tmaList"
                                    :key="index"
                                    class="wrap-name-property">
                        
                        <div class="mb-5px"> <span> Tma Id: </span> {{ item.Id }} </div>
                        <div class="mb-5px"> <span> Название: </span> {{ item.Name }} </div>
                        <div class="mb-5px"> <span> Дата начала: </span> {{ getDateToDisplay(item.StartDate) }} </div>
                        <div class="mb-5px"> <span> Дата окончания: </span> {{ getDateToDisplay(item.EndDate) }} </div>
                        <div class="mb-5px"> <span> Механика: </span> {{ item.Mechanic }} </div>
                        <div class="mb-5px"> <span> Скидка: </span> {{ item.Discount }}% </div>
                        <div class="mb-5px"> <span> ДМП: </span> {{ item.Dmp }} </div>
                        <div class="mb-5px"> <span> Каталог: </span> {{ item.Catalog }} </div>

                        <div v-if="item.Aeps.length"> <a class="admin-link" href="#" @click="showAeps(item)"> Посмотреть Aeps </a> </div>

                    </b-list-group-item>
                </b-list-group>
            </b-col>

            <b-col v-if="isShowAeps">

                <b-list-group>
                    <b-list-group-item class="wrap-name-property">
                        <div id="audit-name"> <h5> {{ tmaSelected.Name }}</h5> </div>
                        <div> <h5>  кол-во {{tmaSelected.Aeps.length}} </h5> </div>
                    </b-list-group-item>

                    <b-list-group-item v-for="(item, index) in tmaSelected.Aeps" :key="index">
                        {{ item }}
                    </b-list-group-item>
                </b-list-group>

            </b-col>

        </b-row>
    </div>
</template>

<script>
import apiService from '@/services/api.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import CustomMultiselect from '@/components/shared/CustomMultiSelect'

export default {
    data: function() {
        let load = new Loading();
        let loadTma = new Loading();

        this.getDaxTtIds(load);

        return {
            load: load,
            loadTma: loadTma,

            daxTtIds: [],
            tmaList: [],

            options: [],
            daxTtIdSelected: null,

            isShowAeps: false,
            tmaSelected: null
        }
    },
    methods: {
        getDaxTtIds: function(load) {
            load.Calculate(true);

            apiService.Admin.Tma.GetDaxTtIds()
                .then(response => {
                    this.daxTtIds = response.data.map((elem, index) => { return { Id: index, Text: elem } });
                    this.options = response.data.map((elem, index) => { return { Id: index, Text: elem } });
                    load.Calculate(false);
                })
                .catch(error => {
                    load.Calculate(false);
                });
        },

        getForDaxTtId: function(value) {
            this.isShowAeps = false;
            this.tmaSelected = null;

            this.loadTma.Calculate(true);

            apiService.Admin.Tma.GetForDaxTtId(value.Text)
                .then(response => {
                    this.tmaList = response.data;
                    this.loadTma.Calculate(false);
                })
                .catch(error => this.loadTma.Calculate(false));
        },

        changeDAXTtId: function(value) {
            this.tmaList = [];
            this.isShowAeps = false;
            this.tmaSelected = null;

            if(value)
                this.options = this.daxTtIds.filter(e => e.Text.toLocaleLowerCase().includes(value.toLocaleLowerCase()));
            else
                this.options = this.daxTtIds;
        },

        getDateToDisplay: function(value) {
            let dateToDisplay = new Date(value);
            dateToDisplay = `${this.getDateString(dateToDisplay)}`;
            return dateToDisplay;
        },

        getDateString(value) {
            const date = `${value.getDate()}`.length == 1
                            ? `0${value.getDate()}`
                            : value.getDate();

            const month = `${value.getMonth() + 1}`.length == 1
                            ? `0${value.getMonth() + 1}`
                            : value.getMonth() + 1;

            const year = value.getFullYear();

            return `${date}.${month}.${year}`;
        },

        showAeps: function(tma) {
            this.isShowAeps = true;
            this.tmaSelected = tma;
        }
    },
    components: {
        Spinner,
        CustomMultiselect
    }
}
</script>